import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=b08c9dc4&scoped=true&"
import script from "./ProductsList.vue?vue&type=script&lang=js&"
export * from "./ProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=b08c9dc4&lang=scss&scoped=true&"
import style1 from "./ProductsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c9dc4",
  null
  
)

export default component.exports